import { trackEvent } from '@/utils/gtags';
import type { NewsCategoryOptionId } from '@/utils/newsCategoryFilter';

/**
 * ### trackNewsCategorySelection
 *
 * Records which newsroom filter a reader moved to, so the split between
 * Industrial and Safety coverage can be read against the unfiltered list.
 * Silently does nothing when the analytics tag is absent, which is the case in
 * development and before consent.
 *
 * @param categoryId The filter that was chosen, `all` for the unfiltered list
 */
export function trackNewsCategorySelection(categoryId: NewsCategoryOptionId) {
  trackEvent('select_content', {
    content_type: 'news_filter',
    item_id: categoryId,
  });
}
